/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */

import api from './api';

export const get = async () => {
    return api.get('currentUser');
};

export const update = async (changes) => {
    return api.patch('currentUser', changes);
};
